module.exports = __webpack_public_path__ + "75c5583e.svg";